var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container home-wrapper relative"},[(_vm.$store.state.cw >= 768)?_c('media-swiper',{attrs:{"list":_vm.list,"urlKey":"link"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }